import {gql} from '@apollo/client';

export const GetSelfIdQuery = gql`
  query GetSelfId {
    self {
      id
    }
  }
`;

export const GetSelfQuery = gql`
  query GetSelf {
    self {
      id
      drmToken
      forensicToken
    }
  }
`;
